<template>
  <div class="commentary" ref="commentaryRef">
    <!-- <Anchor :offset-top="100" show-ink container=".commentary">
      <AnchorLink href="#part1" title="五行表格" />
      <AnchorLink href="#part2" title="链路图" />
      <AnchorLink href="#part3" title="病情解释" />
      <AnchorLink href="#part4" title="易懂性病因病机" />
    </Anchor> -->
    <template v-if="showDetail">
      <div class="block mb0">
        <div class="block-header">
          <span>主诉：{{ info.diagnosticName1 }}</span>
          <span>诊断：{{ info.diagnosticName }}</span>
        </div>
      </div>
      <plan :info="info" @getDataSuccess="getDataSuccess" />
      <div class="block">
        <div class="block-header">病因病机讲解</div>
        <div class="black-body">
          <div class="text-red" v-if="dataInfo.explainType">
            需要讲解病因病机
          </div>
          <div class="text-green" v-else>不需要讲解病因病机</div>
          <div>{{ dataInfo.explainTitle }}</div>
          <div v-if="dataInfo.explainContent">
            {{ dataInfo.explainContent }}
          </div>
          <Form v-if="[4, 5, 7].includes(dataInfo.explainType)" ref="formValidate" :model="formValidate"
            :rules="ruleValidate" label-position="top">
            <FormItem label="请确认患者是否知晓上次讲解的病因病机" prop="knowledgeType">
              <RadioGroup v-model="formValidate.knowledgeType">
                <Radio label="0">不知晓</Radio>
                <Radio label="1">知晓</Radio>
              </RadioGroup>
            </FormItem>
          </Form>
        </div>
      </div>

      <div class="block">
        <div class="block-header">五行分数趋势</div>
        <div class="black-body">
          <wxLineChart v-if="show" :patientCode="info.patientCode" />
        </div>
      </div>

      <div class="block">
        <div class="block-header">当前病情分析</div>
        <div class="black-body">
          <etiologyPathogenesis :dataInfo="dataInfo" :isFocus="isFocus" :info="info" v-if="showEtiologyPathogenesis" />
        </div>
      </div>
    </template>
    <Spin v-else size="large" fix>
      <div v-if="isError">出错了</div>
      <template v-else>
        <Icon type="ios-loading" size="40" class="demo-spin-icon-load"></Icon>
        <div>加载中...</div>
      </template>
    </Spin>
  </div>
</template>

<script>
import plan from "./plan.vue";
import { hasAuth } from "@/utils/uEdition.js";
import etiologyPathogenesis from "./etiologyPathogenesis.vue";
import wxLineChart from "./wxLineChart.vue";
export default {
  components: {
    wxLineChart,
    etiologyPathogenesis,
    plan,
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    show:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      showEtiologyPathogenesis: false,
      isFocus: true, //是否聚焦
      showDetail: false,
      dataInfo: {},
      formValidate: {
        knowledgeType: "", //是否知晓 1 是 0 否",
      },
      ruleValidate: {
        knowledgeType: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      isError: false,
    };
  },
  computed: {},
  methods: {
    getDataSuccess(list) {
      this.showEtiologyPathogenesis = true;
      this.isFocus = list.length ? false : true;
    },
    submit() {
      return new Promise((resolve, reject) => {
        if ([4, 5, 7].includes(this.dataInfo.explainType)) {
          this.$refs["formValidate"].validate((valid) => {
            if (valid) {
              this.changeRadio().then(resolve).catch(reject);
            } else {
              let msg = "请选择患者是否知晓上次讲解的病因病机!";
              this.$Message.error(msg);
              reject(msg);
            }
          });
        } else {
          resolve();
        }
      });
    },
    handleReset() {
      this.$refs["formValidate"].resetFields();
    },
    changeRadio() {
      return new Promise((resolve, reject) => {
        let obj = {
          patientCode: this.info.patientCode, // 患者编码
          symptomNo: this.info.symptomNo, // 单号
          knowledgeType: this.formValidate.knowledgeType, // 是否知晓 1 是 0 否
        };
        this.api2("saveKnowledge", obj)
          .then((res) => {
            this.$Message.success(res.result);
            resolve(res.result);
          })
          .then(reject);
      });
    },

    getData() {
      this.showDetail = false;
      let obj = {
        // 测试 加了个空格
        keywords: this.info.symptom.map((i) => i.dsName).join(","), //	检索关键词

        chiefComplaint: this.info.diagnosticName1, //	主诉名称
        diseaseName: this.info.diagnosticName, //	诊断名(病种)
        diseaseId: this.info.diagnosticId2, //	诊断ID
        hospitalCode: this.info.hospitalCode, //	医馆CODE
        patientCode: this.info.patientCode, //	患者编码
        symptomNo: this.info.symptomNo, //	病历单号
        age: this.info.patientAge, //	年龄
      };
      // console.log("====>",this.info);

      let etiologyReasonList = localStorage.getItem(
        "etiologyReasonList_" + this.info.registerCode
      );
      if (etiologyReasonList) {
        obj.etiologyReasonList = JSON.parse(etiologyReasonList);
      }
      this.isError = false;
      this.api2("symptomDialecticTransSearch", obj)
        .then((res) => {
          let o = res.result;
          o.returnVisitKeywords = obj.keywords;
          o.keywords = o.lastTimeDs
            ? JSON.parse(o.lastTimeDs)
              .map((i) => i.dsName)
              .join(",")
            : "";

          this.dataInfo = o;
          this.showDetail = true;

          // 将"AI升级开方"信息保存到vuex中 处方拟定页可选择使用
          // 有版本限制控制
          if (
            // hasAuth("YZ-16") &&
            this.dataInfo.dialecticDrugs &&
            this.dataInfo.dialecticDrugs.length > 0
          ) {
            let title = this.dataInfo.dialecticDrugs[0].remark;
            this.$store.commit("addMedicalRecordSymptom_add", {
              isShift: false,
              id: this.info.registerCode,
              data: {
                planInfo: {
                  "planName": "",
                  "planExplain": ""
                },
                title: title,
                remark: title,
                active: false,
                drugsList: this.dataInfo.dialecticDrugs,
              },
            });
          }
        })
        .catch((err) => {
          this.isError = true;
        })
        .catch((err) => {
          localStorage.removeItem("dialecticDrugs_" + this.info.symptomNo);
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
.commentary {
  // padding-top: 30px;
  text-align: left;
  height: 100%;
  overflow-y: auto;
  line-height: 2.5em;

  .block {
    margin-bottom: 15px;

    &.mb0 {
      margin-bottom: 0;
    }

    .block-header {
      padding-bottom: 5px;
      font-weight: bold;

      span {
        padding-right: 15px;
      }
    }

    .black-body {
      padding: 15px;
      border: 1px solid #ddd;
    }
  }

  .ivu-card {
    margin-bottom: 15px;

    .ivu-card-head {
      padding: 8px 16px;
      background: #f5f5f5;

      p {
        font-size: 14px;
      }
    }
  }

  .b-title {
    font-weight: bold;
  }

  .group {
    padding-left: 20px;
    position: relative;
    margin-bottom: 10px;

    &::after {
      content: " ";
      display: block;
      clear: both;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background: rgba(0, 0, 0, 0.7);
      position: absolute;
      left: 0;
      top: 14px;
    }
  }

  .red {
    color: #f00;
    font-style: normal;
  }

  .ivu-table-cell {
    height: auto !important;
  }

  .treatment-progress {
    background: none;

    .ivu-progress-inner {
      background: #f5f5f5;
    }
  }

  .tip-info {
    width: 120px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tip-info-body {
      height: 100%;
      display: flex;

      .tib-left {
        border-right: 1px solid #ccc;
        width: 10px;
        margin-right: 15px;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 9px;
          height: 9px;
          position: absolute;
          border: 1px solid #ccc;
          border-width: 1px 0 0 1px;
          right: -5px;
          transform: rotate(45deg);
        }
      }

      .tib-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }

  .table-black {
    width: 100%;
  }

  .ivu-radio-group-item {
    margin-right: 20px;
  }
}
</style>